;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { MSA_DETAILS_STATUS } from '../lib';
import type { User } from './user';

export interface MSADetailsData {
  organisation_id: number;
  user_id?: number;
  job_title?: string;
  status?: (typeof MSA_DETAILS_STATUS)[keyof typeof MSA_DETAILS_STATUS];
  /** Y-m-d; date both parties signed the MSA. */
  signed_date?: string;
  msa_temporary_data?: MSADetailsCacheData | null;
}
export interface MSADetailsCacheData {
  invoice_responsible: {
    type: 'i_am_responsible' | 'other_person' | 'organisation_owner';
    user: User;
  };
  employment_responsible: {
    type: 'i_am_responsible' | 'other_person' | 'organisation_owner';
    user: User;
  };
  msa_signatory: {
    type: 'i_am_responsible' | 'other_person' | 'organisation_owner';
    job_title: string;
    user: User;
  };
  organisation: {
    currency_id: number;
  };
}

export type MSAResponse = {
  id: number;
  organisation_id: number;
  user_id: number;
  job_title: string;
  status: (typeof MSA_DETAILS_STATUS)[keyof typeof MSA_DETAILS_STATUS];
  signed_date?: string | null;
  msa_temporary_data: MSADetailsCacheData | null;
};

export interface MSADetailsStatsRequest {
  organisation_ids?: number[];
  date?: {
    from: string;
    to: string;
  };
}
export interface MSADetailsStatsResponse {
  not_started_count: number;
  awaiting_final_signature_count: number;
  awaiting_the_company_owner_count: number;
  under_review_count: number;
  signed: number;
}
